import { Button, IconTag, StatusTagEnum, StyledFlex, StyledSpinner, Tag, theme } from '@tryhackme/thm-ui-components';
import { LabActionButtonProps } from '../azure-cloud-details-modal.types';
import { StyledPillLabel } from '../azure-cloud-details-modal.styles';
export const LabActionButton = ({
  isDisabled,
  isPerformingAction,
  action,
  handleActionClick
}: LabActionButtonProps) => {
  const hasBeenActionedSuccessfully = action.executionResponse?.status && action.executionResponse?.status.toLowerCase() !== 'error';
  const tagLabel = action.executionResponse?.status ?? 'not actioned';
  const tagColour = hasBeenActionedSuccessfully ? StatusTagEnum.GREEN : StatusTagEnum.RED;
  return <StyledFlex flexDirection="row" justifyContent="flex-start" gap="0.8rem" data-testid="action" data-sentry-element="StyledFlex" data-sentry-component="LabActionButton" data-sentry-source-file="lab-action-button.tsx">
      <Button isDisabled={hasBeenActionedSuccessfully || isDisabled} variant="solid" color="secondary" type="button" size="small" onClick={() => {
      // eslint-disable-next-line no-void
      void handleActionClick(action);
    }} data-sentry-element="Button" data-sentry-source-file="lab-action-button.tsx">
        {action.label}
      </Button>
      {isPerformingAction ? <IconTag>
          <StyledPillLabel>
            <StyledSpinner color={theme.colors.icon.main} />
            &nbsp;working on it...
          </StyledPillLabel>
        </IconTag> : <Tag size="default" status={tagColour} data-testid="status-tag">
          <StyledPillLabel>{tagLabel}</StyledPillLabel>
        </Tag>}
    </StyledFlex>;
};